import { filter, ignoreElements, tap } from "rxjs/operators";
import { selectBuildingInfoById } from "../../../selectors/selectExistingBuildingInfo";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { utilBuildings } from "../../../utils/utilBuildings";
import { TypeActionProductionInfo, } from "../../info/production/actionProductionInfo";
export var epicSoundsBuildingProductionStart = function (action$, state$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionProductionInfo.Start; }), tap(function (action) {
        var state = state$.value;
        var building = selectBuildingInfoById(state, action.buildingId);
        if (building !== undefined) {
            if (utilBuildings.isWindmill(building)) {
                utilSound.event(IdEventSoundCore.ProduceFeed);
            }
            else if (utilBuildings.isSilo(building)) {
                utilSound.event(IdEventSoundCore.ProduceFertilizer);
            }
            else {
                utilSound.event(IdEventSoundCore.ProduceProduct);
            }
        }
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingProductionStart.ts
// module id = 2403
// module chunks = 3